import { useIsHeidi2OptInEnabled } from '@/app-shell/flags/agents-flags';
import { useUserBillingInfo } from '@heidi/commerce/data';
import { HeidiVersion, SubscriptionTier } from '@heidi/schema/ml-scribe';

/**
 * Whether Heidi 2 Clinician trial-extension copy should show.
 * Shared by the gift nav hover card and the tier modal so the two cannot drift.
 */
export function useIsHeidi2Clinician(tier: string | null | undefined): boolean {
  const isHeidi2OptInEnabled = useIsHeidi2OptInEnabled();
  const { data: billingInfo } = useUserBillingInfo();

  return (
    tier === SubscriptionTier.CLINICIAN_PRO &&
    isHeidi2OptInEnabled &&
    billingInfo?.heidi_version === HeidiVersion.Value2
  );
}
